import React, { useEffect, createElement } from 'react';
import './index.css';
import { LandingPage } from './components/LandingPage';
import { ThemeProvider } from './components/ThemeProvider';
import { LanguageProvider } from './components/LanguageProvider';
export function App() {
  useEffect(() => {
    // HubSpot Tracking Code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js.hs-scripts.com/51051096.js';
    document.head.appendChild(script);
    return () => {
      // Cleanup on unmount
      const existing = document.getElementById('hs-script-loader');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <LandingPage data-id="element-2" />
      </LanguageProvider>
    </ThemeProvider>;
}